export const site = {
  name: 'Home Repair MD',
  phone: '(702) 696-8172',
  phoneHref: 'tel:+17026968172',
  license: 'NV Licensed Contractor #0093347',
  city: 'Las Vegas',
  serviceAreas: [
    'Las Vegas',
    'Henderson',
    'Summerlin',
    'North Las Vegas',
    'Spring Valley',
    'Enterprise',
    'Paradise',
    'Boulder City',
  ],
}

export const navLinks = [
  { label: 'Services', href: '#services' },
  { label: 'Our Work', href: '#work' },
  { label: 'Reviews', href: '#reviews' },
  { label: 'About', href: '#about' },
  { label: 'Contact', href: '#contact' },
]

export const images = {
  hero: 'https://cdn.magicpatterns.com/patterns/generated-images/81603fe7-d123-4dff-8f82-65becff9a5e7.jpg',
  before: 'https://cdn.magicpatterns.com/patterns/generated-images/d38576b1-cb68-4acd-bc76-53eb40fcfb1d.jpg',
  after: 'https://cdn.magicpatterns.com/patterns/generated-images/56bc93b7-2cdc-496b-8c69-f9a37016846c.jpg',
  team: 'https://cdn.magicpatterns.com/patterns/generated-images/78840a29-81ea-4a8e-9968-39ee5b047891.jpg',
  flooring: 'https://cdn.magicpatterns.com/patterns/generated-images/d3c00346-3429-4a2f-8625-2bfd0c2b4ddc.jpg',
}
